const LOGO_URL = "https://customer-assets.emergentagent.com/job_lexsant-legal/artifacts/v3889vj4_WhatsApp%20Image%202026-02-17%20at%2016.38.17%20%281%29.jpeg";

const footerLinks = [
  { label: "Sports Law", href: "#practice" },
  { label: "Taxation Advisory", href: "#practice" },
  { label: "Litigation", href: "#practice" },
  { label: "Our Partners", href: "#partners" },
  { label: "Contact", href: "#contact" },
];

const FooterBrand = () => (
  <div className="space-y-4">
    <div className="flex items-center gap-3">
      <img src={LOGO_URL} alt="LexSant" className="h-10 w-10 rounded object-cover" />
      <span className="font-heading text-xl text-white tracking-tight">LexSant</span>
    </div>
    <p className="text-sm text-gray-500 font-body leading-relaxed">
      LexSant Legal & Advisory LLP
    </p>
    <p className="text-sm text-gray-500 font-body">
      Advisory and litigation. Under one roof. Across India.
    </p>
  </div>
);

const FooterQuickLinks = ({ onLinkClick }) => (
  <div className="space-y-4">
    <h4 className="text-sm tracking-widest uppercase text-gold/60 font-body">Quick Links</h4>
    <div className="space-y-3">
      {footerLinks.map((link, i) => (
        <button
          key={link.label}
          onClick={() => onLinkClick(link.href)}
          data-testid={`footer-link-${i}`}
          className="block text-sm text-gray-400 hover:text-gold font-body transition-colors"
        >
          {link.label}
        </button>
      ))}
    </div>
  </div>
);

const FooterContact = () => (
  <div className="space-y-4">
    <h4 className="text-sm tracking-widest uppercase text-gold/60 font-body">Contact</h4>
    <div className="space-y-3 text-sm text-gray-400 font-body">
      <p>C298, Defence Colony, New Delhi, India</p>
      <a href="tel:+919914601473" className="block hover:text-gold transition-colors" data-testid="footer-phone">
        +91-9914601473
      </a>
      <a href="mailto:garvilsingh@lexsant.com" className="block hover:text-gold transition-colors" data-testid="footer-email">
        garvilsingh@lexsant.com
      </a>
      <a href="mailto:samarthdhumal@lexsant.com" className="block hover:text-gold transition-colors" data-testid="footer-email-2">
        samarthdhumal@lexsant.com
      </a>
    </div>
  </div>
);

const FooterLegal = () => (
  <div className="border-t border-gold/10 pt-8 space-y-4">
    <p className="text-xs text-gray-600 font-body leading-relaxed max-w-4xl">
      <strong className="text-gray-500">Disclaimer:</strong> This website is for informational purposes only and does not constitute legal advice. 
      Communication through this site does not establish an attorney-client relationship. The information provided should not be 
      construed as solicitation or advertisement under the Bar Council of India Rules.
    </p>
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <p className="text-xs text-gray-600 font-body">
        &copy; {new Date().getFullYear()} LexSant Legal & Advisory LLP. All rights reserved.
      </p>
      <div className="flex gap-6 text-xs text-gray-600 font-body">
        <span className="hover:text-gold/60 cursor-pointer transition-colors">Privacy Policy</span>
        <span className="hover:text-gold/60 cursor-pointer transition-colors">Disclaimer</span>
      </div>
    </div>
  </div>
);

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="bg-navy-dark border-t border-gold/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <FooterBrand />
          <FooterQuickLinks onLinkClick={scrollTo} />
          <FooterContact />
        </div>
        <FooterLegal />
      </div>
    </footer>
  );
}
